module.exports = __webpack_public_path__ + "static/media/yen-sign.fe8cc90d.svg";